import { Typography } from "@mui/material"
import type { FC } from "react"

interface AdjustmentDuplicateLotErrorProps {
  "data-testid"?: string
}

export const AdjustmentDuplicateLotError: FC<AdjustmentDuplicateLotErrorProps> = ({ "data-testid": testId }) => (
  <Typography variant='caption' className='text-secondary-600' data-testid={testId}>
    This Lot # + Batch # + Pkg UoM combination already exists on this pallet. Duplicate lots are not allowed.
  </Typography>
)
